import {url} from './api.url'

let addExamAnswersURL = url +  "exam_answers/add_exam/"
let getExamAnswersURL = url + "exam_answers/"

export async function examSubmit(participant,results){
    const formatYmd = date => date.toISOString().slice(0, 10);
    let fecha = formatYmd(new Date())
    // participant.phone = participant.phone.replaceAll('-','')
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            fecha: fecha,
            nivelId: 1,
            empresaId: 2,
            nombreAlumno: participant.name+" "+participant.lastName,
            correo: participant.email,
            telefono: participant.phone,
            cantidadValidas: results.correctCount,
            cantidadFallidas: results.incorrectCount,
            calificacion: results.grade,
            calificacionLetra: results.letter,
            nombreEmpresa: participant.company
        })
    };
    // console.log("TO POST:",requestOptions)
   return await fetch(url+"exams", requestOptions)
        .then(response => response.json())
        .then(data => {
            // console.log("DATA",data)
            // postExamAnswers(data.examenID,results.answers)
            return data;
        } );
}

async function postExamAnswer(IDExamen,answer){
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
          examenId: IDExamen,
          respuesta: answer,
      })
  };
//   console.log("EXAM ANSWERS POST:",requestOptions)
  fetch(addExamAnswersURL+IDExamen, requestOptions)
      .then(response => response.json())
      .then(data => {});
  }

async function postExamAnswers(IDExamen,answers){
    answers.forEach(answer=>{
        postExamAnswer(IDExamen,answer)
    })
}

  export async function getExamAnswers(IDExamen){
    const res = await fetch(
        getExamAnswersURL + IDExamen);
        const json = await res.json();
        // console.log("exam selection:",json)
        return json;   
  }